import * as Sentry from '@sentry/react'
import { createBrowserHistory } from 'history'

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
const isProduction = process.env.REACT_APP_ENV_NAME === 'PRODUCTION'
const history = createBrowserHistory()

isProduction &&
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
      }),
    ],
    beforeSend(event, hint) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const error = hint.originalException as any
      console.log({ error }, 'sentry error')
      console.log({ event, hint }, 'event and hint')
      if (hint.originalException === 'Timeout') return null
      if (
        event !== undefined &&
        event?.exception !== undefined &&
        event?.exception?.values !== undefined &&
        event?.exception?.values?.length === 1
      ) {
        const e = event?.exception?.values[0]
        if (
          e.type === 'UnhandledRejection' &&
          e.value === 'Non-Error promise rejection captured with value: '
        ) {
          return null
        }
      }

      if (event.exception && event.exception.values) {
        for (const error of event.exception.values) {
          if (
            error.type === 'TypeError' &&
            error.stacktrace &&
            error.stacktrace.frames
          ) {
            for (const frame of error.stacktrace.frames) {
              if (frame.filename && frame.filename.includes('recaptcha')) {
                return null
              }
            }
          }
        }
      }
      return event
    },
    ignoreErrors: [
      // Error timetout
      /timeout/,
      // NotFound error after clear DOM
      /Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node./,
    ],
    tracesSampleRate: 0.2, //  Capture 20% of the transactions
  })
